module.exports = __webpack_public_path__ + "img/renzheng.b7d37d0d.png";